export default {
  simpleIndex: '指数信息汇总',
  index: '商城指数',
  jescard: '品牌指数',
  top: '点击指数',
};
